import { MessageItemAggregate } from '../../message/item';
import { MessageSectionAggregate } from '../../section';

// Helper function to group message aggregates by day
export function groupMessagesByDay(
    messageItems: MessageItemAggregate[]
): MessageSectionAggregate[] {
    if (!messageItems || messageItems.length === 0) {
        return [];
    }

    const dayGroups: MessageSectionAggregate[] = [];

    for (const messageItem of messageItems) {
        const message = messageItem.message;
        const messageDate = new Date(message.createdAt);
        const dateString = messageDate.toDateString();

        // Find existing day group or create new one
        let dayGroup = dayGroups.find((dg) => dg.date.toDateString() === dateString);

        if (!dayGroup) {
            dayGroup = {
                id: `day-${dateString}`,
                date: messageDate,
                messages: [],
            };
            dayGroups.push(dayGroup);
        }

        // Add message to the day group (dayGroup is guaranteed to exist here)
        dayGroup.messages.push(messageItem);
    }

    return dayGroups.sort((a, b) => a.date.getTime() - b.date.getTime());
}
